import NodeLink from '@frontastic/catwalk/src/js/app/nodeLink';
import Reference from '@frontastic/catwalk/src/js/component/reference';
import clsx from 'clsx';
import { Link as RouterLink } from 'react-router-dom';
import styles from './Link.module.scss';

export const Link = ({
  children,
  link = null,
  className = '',
  ref = null,
  onClick = () => {},
  dataButtonType = '',
  variables = {},
  ariaLabel = '',
  ...rest
}) => {
  const getNode = (target) => {
    return {
      nodeId: target,
      target: target,
      type: 'node',
    };
  };

  switch (true) {
    case !link?.reference?.type:
      return (
        <RouterLink
          ref={ref}
          data-buttontype={dataButtonType}
          className={className}
          itemProp="url"
          to={link?.reference?.target || link || ''}
          onClick={onClick}
          style={variables}
          aria-label={ariaLabel}
          {...rest}
        >
          {children ? children : link.label ? link.label : link.name}
        </RouterLink>
      );

    case link?.reference?.type === 'node' && link?.reference?.mode !== 'new_window':
      return (
        <NodeLink
          ref={ref}
          data-buttontype={dataButtonType}
          className={className}
          node={getNode(link?.reference?.target || '')}
          onClick={onClick}
          style={variables}
          aria-label={ariaLabel}
          {...rest}
        >
          {children ? children : link.item || (link.label ? link.label : link.name)}
        </NodeLink>
      );
    default:
      return (
        <span
          className={clsx(className, styles.reference)}
          data-buttontype={dataButtonType}
          style={variables}
          {...rest}
        >
          <Reference ref={ref} itemProp="url" reference={link.reference} onClick={onClick} aria-label={ariaLabel}>
            {children ? children : link.label ? link.label : link.name}
          </Reference>
        </span>
      );
  }
};
